<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-building"></span>{{ 'bikeshop.menu.switch_shop' | translate }}</div>
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>
    <div class="content">


        <!--<div class="row margin-top-16">
            <div pTooltip="Create a new cyclist" tooltipPosition="left" class="fa fa-partner-plus font-button pull-right"
              style="margin-left: auto!important;margin-right: 16px!important;" (click)="addpartner()"></div>
          </div>-->
        <div class="margin-top-16">
            <p-table #partnersTable [columns]="columns" [value]="partners" [paginator]="true" [rows]="10">
                <ng-template pTemplate="caption">
                    <div class="flex">
                        <div style="margin-left: auto;" class="p-inputgroup">
                            <!--           todo (dcorbett) $event.target.value doesnt work-->
                            <input type="text" pInputText size="50" placeholder="Search"
                                   (input)="partnersTable.filterGlobal($event.target['value'] , 'contains')"
                                   style="width:auto">
                            <span class="p-inputgroup-addon"><i class="fa hubtiger-search"></i></span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'">
                            </p-sortIcon>
                        </th>
                        <th style="width: 230px;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-partner let-columns="columns">
                    <tr [pSelectableRow]="partner">
                        <td *ngFor="let col of columns">
                            <div *ngIf="col.type!=='action'">
                                {{
                                col.type === 'boolean' ?
                                    (partner[col.field] ? "Yes" : "No")
                                    : partner[col.field]
                                }}
                            </div>
                        </td>
                        <td style="text-align:left;    padding: 8px 8px!important;">
                            <button pButton label="{{ 'bikeshop.switch_shop.switch_to_this_shop' | translate }}"
                                    class="p-button-raised alternate full-width" [disabled]="partnerID === partner.ID"
                                    (click)="switchShop(partner)"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
</div>
<p-confirmDialog></p-confirmDialog>
